// Pre-compile regex patterns for better performance
const RUBY_CONVERSION_PATTERNS = {
  arrowToColon: /=>/g,
  nilToNull: /nil/g,
  falseToFalse: /false/g,
  trueToTrue: /true/g,
  quoteKeys: /(?<!")([a-zA-Z_][a-zA-Z0-9_]*)\s*:/g,
} as const;

/**
 * Converts Ruby hash syntax to valid JSON
 * @param rubyString - String containing Ruby hash syntax
 * @returns Valid JSON string
 */
export function convertRubyHashToJson(rubyString: string): string {
  let result = rubyString
    .replace(RUBY_CONVERSION_PATTERNS.arrowToColon, ':')
    .replace(RUBY_CONVERSION_PATTERNS.nilToNull, 'null')
    .replace(RUBY_CONVERSION_PATTERNS.falseToFalse, 'false')
    .replace(RUBY_CONVERSION_PATTERNS.trueToTrue, 'true');

  // Quote unquoted keys first
  result = result.replace(/([a-zA-Z_][a-zA-Z0-9_]*)\s*:/g, '"$1":');

  // Remove extra spaces after colons
  result = result.replace(/"\s*:/g, '":');

  // Fix malformed URLs with extra quotes around "https" and "http" - do this last
  result = result.replace(/"https"/g, 'https').replace(/"http"/g, 'http');

  return result;
}
